module.exports = __webpack_public_path__ + "static/img/img_tip4.c62b8607.png";